import { StyledBackdrop } from './Backdrop.styles';
import { IBackdropProps } from './Backdrop.types';

const Backdrop = ({ onClick }: IBackdropProps): JSX.Element => {
  return (
    <StyledBackdrop
      onClick={onClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    />
  );
};

export default Backdrop;
